// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__37Abe","label":"Section_label__pc7Au","contentWrap":"Section_contentWrap__1ydLl","footer":"Section_footer__-dGiI","footerInner":"Section_footerInner__205c_"};